import React from "react";

import CmsPreviewShell from "./CmsPreviewShell";
import mockData from "./mockData.json";

import type { CmsComponentProps, ReviewMock } from "./types";

const ReviewComponent: React.FC<CmsComponentProps> = ({ title, layout, items: userItems }) => {
  const items: ReviewMock[] =
    userItems && userItems.length > 0
      ? userItems
          .filter((i) => i.is_active !== false)
          .map((i, idx) => ({
            id: idx,
            title: i.title,
            description: i.description ?? "",
            img: i.img ?? "",
            author: i.author ?? "",
            rating: Math.max(0, Math.min(5, Math.round(i.rating ?? 0))),
          }))
      : (mockData.review as ReviewMock[]);

  return (
    <CmsPreviewShell title={title}>
      <div className={`cms-review cms-review--${layout}`}>
        {items.map((item) => (
          <div key={item.id} className="cms-review__item">
            <div className="cms-review__thumb">{item.img ? <img src={item.img} alt={item.title} /> : <div className="cms-review__placeholder">이미지 없음</div>}</div>
            <div className="cms-review__body">
              <div className="cms-review__rating">
                {"★".repeat(item.rating)}
                {"☆".repeat(5 - item.rating)}
              </div>
              <h5 className="cms-review__title">{item.title}</h5>
              {item.description && <p className="cms-review__desc">{item.description}</p>}
            </div>
          </div>
        ))}
      </div>
    </CmsPreviewShell>
  );
};

export default ReviewComponent;
